<template>
    <div class="product-services">
        <DefSlider
                :nav="$store.state.global.screenWidth <= 992"
                :settings="settings"
                ref="slider"
        >
            <div
                    v-for="(item, key) in services"
                    :key="key"
                    class="swiper-slide"
            >
                <div>
                    <img :src="item.src" :alt="item.title" width="46">
                </div>
                <div class="product-services__title">
                    {{ item.title }}
                </div>
                <div class="product-services__text">
                    {{ item.text }}
                </div>

            </div>
        </DefSlider>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import DefSlider from "../Def/DefSlider/DefSlider.vue";
    export default {
        name: 'ProductServices',
      components: {DefSlider},
        selector: '.product-services',
        data() {
            return {
                settings: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 5000,
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                            autoplay: false,
                        },
                    }
                },
            }
        },
        computed: {
            ...mapState({
                services: ({ product }) => product.data.services,
            }),
        },
    }
</script>

<style lang="scss" scoped>
    .product-services{
        &__title {
            font-size: rem(20);
            padding: 15px;
        }
        &__text {
            color: #929699;
        }
        .swiper-slide {
            text-align: center;
            &:not(:last-child) {
                border-right: 1px solid #e0dbd5;
            }
        }
        ::v-deep{
            .swiper-wrapper {
              justify-content: center;
            }
            @media (max-width: 992px) {
                .def-slider__next{
                    right: 0;
                }
                .def-slider__prev{
                    left: 0;
                }
                .swiper-wrapper {
                  justify-content: inherit;
                }
            }
        }
    }
</style>